import PropTypes from 'prop-types'
import styled from 'styled-components'
import { components } from 'react-select'

import { InnerComponent } from 'components/utils/innerReactSelectComponents'

const SingleValueWrapper = styled(InnerComponent).attrs({ Component: components.SingleValue })`
  && {
    margin: 0 2px 0 0;
    height: 16px;
  }
`

const SingleValueWithIcon = styled.div`
  display: flex;
  align-items: center;
  line-height: 16px;
}`

const SingleValue = props => {
  const { iconComponentsMap } = props.selectProps

  if (!iconComponentsMap) {
    return <SingleValueWrapper {...props} />
  }

  const value = props.data.value
  const OptionComponent = () => iconComponentsMap[value]

  return (
    <SingleValueWrapper {...props}>
      <SingleValueWithIcon>
        <OptionComponent />
        {props.data.label}
      </SingleValueWithIcon>
    </SingleValueWrapper>
  )
}

SingleValue.propTypes = {
  data: PropTypes.object,
  selectProps: PropTypes.object,
}

export default SingleValue
